<template>
    <div :class="$common.getClassName('website')">
        <!--loading-->
        <div :class="$common.getClassName('loading')"  v-show="loadingStatus">
            <div :class="$common.getClassName('loading-wrap')"></div>
            <div :class="$common.getClassName('loading-animate')"></div>
        </div>
        <!--loading end-->
        <!--head-->
        <div :class="$common.getClassName('head')" v-show="$appConfig.PARAMS.head === 'Y' && $pageLoadedDone">
            <div :class="$common.getClassName('head-warper')">
                <div :class="$common.getClassName('head-l')"><span v-html="$t('web_title')"></span></div>
                <div :class="$common.getClassName('head-r')"><span>UID: </span><strong v-html="$appConfig.PARAMS.user_id"></strong></div>
                <div class="clear"></div>
            </div>

        </div>
        <!--head end-->
        <!--body-->
        <div :class="$common.getClassName('body-warper')">
            <div :id="$common.getClassName('payment-box')" v-show="$pageLoadedDone">
                <div :class="$common.getClassName('body-top')"></div>
                <div :class="$common.getClassName('body')" >
                    <div :class="$common.getClassName('server')" >
                        <Servers></Servers>
                    </div>
                    <div :class="$common.getClassName('region')"  v-if="!$noChannelData">
                        <Countrys></Countrys>
                    </div>
                    <div :class="$common.getClassName('package')">
                        <PackageBoxs></PackageBoxs>
                    </div>
                    <div :class="$common.getClassName('safe')">
                        <span><img :src="getImageUrl('safe_2.jpg')"></span>
                        <span><img :src="getImageUrl('safe_1.jpg')"></span>
                        ddd
                    </div>
                </div>
                <div :class="$common.getClassName('body-bottom')"></div>
            </div>
        </div>
        <!--body end-->
        <!--footer-->
        <div :class="$common.getClassName('footer')" v-if="$appConfig.PARAMS.footer === 'Y' && $pageLoadedDone">
            <iframe :class="$common.getClassName('in-footer')" scrolling="no" frameborder="0" allowtransparency="true" src="//img.oasgames.com/uploads/167757592215817.png"></iframe>
        </div>
        <!--footer end-->
        <!--pop-->
        <div :class="`${$common.getStyleName('payment-pop')} ${$appConfig.PARAMS.lang==='ar-AE' ? `${$common.getWebSiteName()}-ar`: `${$common.getWebSiteName()}-other`}`" :style="setPayPop()" v-show="$popStatus.show">
            <div :class="$common.getStyleName('payment-pop-warp')" v-if="!$popStatus.isIframe">
                <div :class="$common.getStyleName('payment-pop-title')">{{$popStatus.title}}<i @click="$POP_HIDE_HANDLE()" :class="$common.getStyleName('payment-pop-close')"></i></div>
                <div :class="$common.getStyleName('payment-pop-desc')" v-html="$popStatus.desc"></div>
                <div :class="$common.getStyleName('payment-pop-btn')">
                    <a :class="$common.getStyleName('payment-pop-ok')" @click="$POP_CONFIRM_HANDLE()" v-show="$popStatus.btn.yes" href="javascript:void(0);"><span>{{$t('pop_yes')}}</span></a>
                    <a :class="$common.getStyleName('payment-pop-no')" @click="$POP_HIDE_HANDLE()" v-show="$popStatus.btn.no" href="javascript:void(0);"><span>{{$t('pop_no')}}</span></a>
                </div>
            </div>
            <div :class="$common.getStyleName('payment-pop-warp-iframe')" :style="`height:${$popStatus.iframeWH.height-2}px;width:${$popStatus.iframeWH.width-2}`" v-if="$popStatus.isIframe">
                <div :class="$common.getStyleName('payment-pop-title')">{{$popStatus.title}}<i @click="$POP_HIDE_HANDLE()" :class="$common.getStyleName('payment-pop-close')"></i></div>
                <div :class="$common.getClassName('inline-loading')" :style="`height:${$popStatus.iframeWH.height-32}px`" v-if="loading">
                    <div :class="$common.getClassName('inline-loading-wrap')" ></div>
                    <div :class="$common.getClassName('inline-loading-animate')"></div>
                </div>
                <iframe :src="$popStatus.iframeUrl" frameborder="0" :height="$popStatus.iframeWH.height-32" :width="$popStatus.iframeWH.width-2"></iframe>
            </div>
        </div>
        <!--pop end-->
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
    import Servers from "./servers/Index";
    import Countrys from "./country/Index";
    import PackageBoxs from "./packagebox/Index";
    import $ from "jquery";


    export default {
        name: 'app',
        components: {
            Servers,
            PackageBoxs,
            Countrys
        },
        data() {
            return {
                loadIframeDone: false,
                loadingStatus : true,
                loading: true
            }
        },
        computed: {
            ...mapState(['$appConfig', '$common', '$pageLoadedDone', '$pageLoadedIcon', '$popStatus', '$lang', '$footerUrl','$noChannelData','$lodash']),
            ...mapState('Module_Access', ['userAccessStatus']),
        },
        created() {
            //设置title
            document.title = this.$t('web_title');

            let me = this;
            //绑定页面回车事件
            $(window).keydown(function (event) {
                if (event.keyCode === 13 && me.$popStatus.show) {
                    me.$POP_CONFIRM_HANDLE();
                } else {
                    console.log(event.keyCode);
                }
            });

            /**
             * 加载样式
             */
            this.$LOAD_STYLE_HANDE({
                className: 'app',
                callback() {

                    /**
                     * 判断用户id，游戏code不能为空
                     */
                    if (!me.$appConfig.PARAMS.user_id || !me.$appConfig.PARAMS.merchant_shop_code) {
                        me.appNoParams = false;
                        me.$POP_SHOW_HANDLE({
                            show: true,
                            title: me.$lang.tips_text,
                            desc: me.$lang['params_not_empty'],
                            callback($state, popDeflaut) {
                                $state.$popStatus = popDeflaut;
                            }
                        });
                        return;
                    }

                    /**
                     * 开发境免登陆
                     */
                    if(me.$appConfig.environment === 'dev') {
                        //加载主体样式表
                        me.$LOAD_STYLE_HANDE();

                        //加载风控系统
                        me.ACCESS_INIT();

                        return;
                    }

                    /**
                     * 检查用户是否登陆
                     */
                    me.checkUserLogin(me.$appConfig)
                    .then((res) => {
                        /**
                         * 用户传入UID与登陆UID一致
                         */
                        if (res['user_id'] === me.$appConfig.PARAMS.user_id) {
                            //加载主体样式表
                            me.$LOAD_STYLE_HANDE();

                            //加载风控系统
                            me.ACCESS_INIT();
                        }
                        else
                        {
                            let reg = /uid=([^&]*)/;
                            window.location.href = window.location.href.replace(reg, `uid=${res['user_id']}`);
                        }
                    })
                    .catch((res) => {
                        /**
                         * 未登陆
                         */
                        if (res.type === 'nologin') {
                            let login_url = '';
                            let actUrl = encodeURIComponent(window.location.href);
                            let params = `lang=${me.$common.getLang5to2Value(me.$appConfig.PARAMS.lang)}&callback=${actUrl}`;
                            if (res.res['login_url'].indexOf('?') === -1) {
                                login_url = `${res.res['login_url']}?${params}`;
                            } else {
                                login_url = `${res.res['login_url']}&${params}`;
                            }
                            window.location.href = login_url;
                        }
                        /**
                         * 网络错误或者服务器错误
                         */
                        if (res.type === 'error') {
                            console.log(res.res)
                        }
                    });
                }
            });
        },

        watch: {
            userAccessStatus: function (val) {
                if (val === true) {
                    //加载应用LOGO
                    this.GET_APP_LOGO();
                }
            },

            $pageLoadedIcon(val){
                this.loadingStatus = val;
            },
            '$popStatus.show'(val) {
                if(val) {
                    setTimeout(() => {
                        this.loading = false;
                    }, 2000)
                } else {
                    this.loading = true;
                }
            }
        },

        methods: {
            ...mapActions(['$POP_HIDE_HANDLE', '$POP_SHOW_HANDLE', '$POP_CONFIRM_HANDLE', '$LOAD_STYLE_HANDE']),
            ...mapActions('Module_Access', ['ACCESS_INIT', 'GET_APP_LOGO']),
            ...mapActions('Module_Logo', ['GET_APP_LOGO']),

            setPayPop() {
                if (this.$popStatus.isIframe) {
                    let width = this.$popStatus.iframeWH.width;
                    return `width: ${width}px;`;
                }
                return '';

            },

            /**
             * 获取当前域名所有cookie
             */
            getAllCookie(){
                let cookies = document.cookie;
                let allCookiesArr = cookies.split('; ');
                let cookieObj = {};
                for(let key in allCookiesArr){
                   let item = allCookiesArr[key].split('=');
                    cookieObj[item[0]] = decodeURIComponent(item[1]);
                }
                return cookieObj;
            },

            /**
             * 检查用户是否登陆成功
             */
            checkUserLogin(appconfig) {

                let me = this;
                let tpl = appconfig.getVersionInfo();
                let url = tpl.api.app_base_url + tpl.api.app_check;
                let cookies = this.getAllCookie();
                let data = this.$lodash['merge']({}, cookies,{
                    merchant_shop_code: appconfig.PARAMS.merchant_shop_code,
                    user_id: appconfig.PARAMS.user_id,
                    merchant_id: appconfig.PARAMS.merchant_id
                });
                return new Promise((resolve, reject) => {
                    me.$common.ajax({
                        url: url,
                        type: 'post',
                        data: data,
                        success(res){
                            if(res && res.code === 200) {
                                /**
                                 * 登陆成功
                                 */
                                if(res.result.status === 1) {
                                    resolve(res.result);
                                }

                                /**
                                 * 未登陆
                                 */
                                if(res.result.status === 0) {
                                    reject({type: 'nologin', res: res.result});
                                }
                            }

                        },
                        error(res){
                            reject({type: 'error', res: res});
                        }
                    })
                })
            },

            /**
             * 获取assetsPath
             */
            getImageUrl(file){
                return `${this.$appConfig.host }/static/${file}?version=${this.$common.version}`;
            }
        }

    };
</script>

<style type="scss">
</style>



// WEBPACK FOOTER //
// website/components/App.vue